import Cookies from 'js-cookie';

import cookieDomainHelper from '../helpers/cookieDomainHelper';
import ROUTES from '../../components/Routes/constants/index';

export const expireCookie = cookieName => {
  Cookies.remove(cookieName, {
    domain: cookieDomainHelper(ROUTES.TR4_ENDPOINT)
  });
};

export const createCookie = (key, value) => {
  Cookies.set(key, value, {
    domain: cookieDomainHelper(ROUTES.TR4_ENDPOINT),
    sameSite: 'Lax'
  });
};

export const getCookie = key => {
  return Cookies.get(key) || sessionStorage.getItem(key);
};
